import React from 'react';

import { stopEventPropagation } from '@lyearn/core/utils/events';
import { cn } from '@lyearn/style';
import { Image, LinkButton, Stack, Typography } from '@lyearn/ui';
import { ProviderType } from '@/types/schema';

import { useActionItemContext } from '../../context';
import { ActionItemFragment } from '../../graphql/fragments/generated/ActionItem';

const LinkContainer: React.FC<React.PropsWithChildren<{ hyperlink?: string | null }>> = ({
  hyperlink,
  children,
}) => {
  if (!!hyperlink) {
    return (
      <LinkButton
        className="py-2 px-4 pt-0 pb-0 ps-0 pe-0"
        color={'external'}
        href={hyperlink}
        rel="noreferrer"
        target="_blank">
        <Typography className="flex flex-row items-center" variant="body-short-02">
          {children}
        </Typography>
      </LinkButton>
    );
  }

  return (
    <Typography className="flex flex-row" color="text-text-secondary" variant="body-short-02">
      {children}
    </Typography>
  );
};

export function ProviderComp({
  className,
  actionItem,
  provider,
  mini,
}: {
  className?: string;
  actionItem: ActionItemFragment;
  provider?: ProviderType;
  mini?: boolean;
}) {
  if (provider) {
    return (
      <Stack
        alignItems="center"
        className={cn('flex-shrink-0', className)}
        onClick={stopEventPropagation}>
        <LinkContainer hyperlink={actionItem.externalLink}>
          <Image alt={provider.name} className="h-20 w-20 me-8" src={provider.logo.url || ''} />
          {!mini ? actionItem.metadata?.displayName : null}
        </LinkContainer>
      </Stack>
    );
  }

  return null;
}

function Provider({ className, mini }: { className?: string; mini?: boolean }) {
  const { actionItem, provider } = useActionItemContext();

  return (
    <ProviderComp actionItem={actionItem} className={className} mini={mini} provider={provider} />
  );
}

export default Provider;
